import { DEBUG } from './debug';
import { ICollidable, Bounds } from './collision/types';
import { Cat } from './cat';

export class Pit implements ICollidable {
	x: number;
	y: number;
	width: number;
	height: number;
	groundY: number;
	readonly collisionType = 'pit';
	private landTileLeft: p5.Image | null = null;
	private landTileRight: p5.Image | null = null;

	constructor(x: number, groundY: number, width: number = 60, height: number = 144) {
		this.x = x;
		this.groundY = groundY;
		this.y = groundY;
		this.width = width;
		this.height = height;
	}

	setLandTiles(leftTile: p5.Image, rightTile: p5.Image): void {
		this.landTileLeft = leftTile;
		this.landTileRight = rightTile;
	}

	getBounds(): Bounds {
		return {
			x: this.x,
			y: this.y,
			width: this.width,
			height: this.height,
		};
	}

	isActive(): boolean {
		return true; // Pit is always active
	}

	onCollision(other: ICollidable): void {
		// When cat collides with pit, trigger falling logic
		if (other instanceof Cat) {
			other.handlePitCollision(this);
		}
	}

	/**
	 * Get the bottom Y coordinate of the pit (for death zone)
	 */
	getBottomY(): number {
		return this.y + this.height;
	}

	draw(): void {
		// Main pit (darker brown)
		fill(50, 25, 0);
		rect(this.x, this.y, this.width, this.height);
		// Pit edges (even darker)
		fill(30, 15, 0);
		rect(this.x + 5, this.y, 10, this.height);
		rect(this.x + this.width - 15, this.y, 10, this.height);

		// Land tiles at pit edges (at ground level, not pit top)
		if (this.landTileLeft && this.landTileRight) {
			const tileSize = 16;
			// Left edge: right corner tile (pit's left edge = ground's right corner)
			image(this.landTileRight, this.x - tileSize, this.groundY);
			// Right edge: left corner tile (pit's right edge = ground's left corner)
			image(this.landTileLeft, this.x + this.width, this.groundY);
		}

		// Draw bounding box in yellow (debug)
		if (DEBUG.COLLISION) {
			noFill();
			stroke(255, 255, 0);
			strokeWeight(2);
			const bounds = this.getBounds();
			rect(bounds.x, bounds.y, bounds.width, bounds.height);
		}
	}
}
